import React, { useState } from 'react';
import { Button } from '../../../../global/components/Button';
import { ObservationCreateModal } from './ObservationCreate';

export * from './ObservationCreate';

export const ObservationCreateFab = (props) => {
  const { activeEdit, hasSubScores } = props;
  const [state, setState] = useState({
    open: false,
  });

  return !hasSubScores || !!activeEdit ? null : (
    <>
      <Button style={{ marginLeft: 8, ...(props.style || {}) }} color="secondary" onClick={() => setState((s) => ({ ...s, open: !s.open }))} icon={'add'}>
        Add
      </Button>
      <ObservationCreateModal {...props} open={state.open} onClose={() => setState((s) => ({ ...s, open: false }))} />
    </>
  );
};
